<template>
  <div class="asc-unauthorized-wrapper">
    <img id="logo" src="../../assets/collins-logo.png" />
    <div class="panel">
      <h2>{{ getTitle }}</h2>
      <h4>
        {{ getSubtitle }}
      </h4>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AscUnauthorizedWrapper',

  computed: {
    getTitle() {
      return 'YOU DO NOT HAVE AUTHORIZED ACCESS'
    },

    getSubtitle() {
      return 'For assistance, please contact your system administrator.'
    },
  },
}
</script>

<style lang="scss">
body {
  height: 100%;
}

.asc-unauthorized-wrapper {
  height: 100%;
  -webkit-animation: fadein 1s;
  animation: fadein 1s;
  width: 100%;
  z-index: 0;
  position: fixed;
  left: 0;
  overflow: hidden;
  top: 0;
  padding: 20px;
  background-image: url('../../assets/flightbackground_large.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;

  #logo {
    width: 286px;
  }

  .panel {
    background: $primary-white;
    max-width: 284px;
    padding: 60px 20px 20px 20px;
    min-height: 366px;
    position: relative;
    top: 74px;

    @media only screen and (max-width: 600px) {
      top: 10%;
    }

    @include surface-shadow;

    a {
      color: $accent-600;
    }
  }

  h2 {
    font-weight: bold;
    font-size: $font-size-xl;
    margin-bottom: 30px;
  }

  h4 {
    font-weight: normal;
  }
}
</style>
